module.exports = __webpack_public_path__ + "static/media/14.017a9a1f.jpeg";